import { HttpClient } from '@store/base';
import _ from 'lodash';
import {
  RequestGoodsRestockNotifyRequest,
  RequestGoodsRestockNotifyResponse,
} from '../../model';

export class RequestGoodsRestockNotifyGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: RequestGoodsRestockNotifyRequest) {
    req.unitNo = req.unitNo || 0;
    req.unitNm = req.unitNm || '<기본단품>';
    return await this.httpClient.request<RequestGoodsRestockNotifyResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/restock-notify`,
      body: _.omit(req, 'gdsNo'),
    });
  }
}
